import { render, staticRenderFns } from "./beLost.vue?vue&type=template&id=ca2de3de&scoped=true&"
import script from "./beLost.vue?vue&type=script&lang=js&"
export * from "./beLost.vue?vue&type=script&lang=js&"
import style0 from "./beLost.vue?vue&type=style&index=0&id=ca2de3de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2de3de",
  null
  
)

export default component.exports